export default __webpack_public_path__ + "static/media/paypal-logo-129x32.1a2ed1f8.svg";